export const COLUMN_DEFAULTS = {
    sortable: true,
    minWidth: 168,
    filter: false as const,
};

export const PAGE_SIZE = {
    table: 20,
    sub: 10,
};

export const STORAGE_PREFIX = 'ics-table:v1:';

export const URL_PARAM = {
    filter: 'f.',
    lockedFilter: 'lf.',
    sort: 's.',
    search: 'q.',
};

export const DEBOUNCE = {
    search: 300,
    layout: 300,
};

export const STRUCTURAL = {
    select: '__select',
    expand: '__expand',
    menu: '__menu',
    drag: '__drag',
} as const;

export const STRUCTURAL_IDS: string[] = Object.values(STRUCTURAL);

export const RIGHT_ALIGNED = ['number', 'rating'];

export const CENTER_ALIGNED = ['icon'];
